import { LogState } from "./state";
import { getStoreAccessors } from "typesafe-vuex";
import { State } from "../state";

export const getters = {
  logContent: (state: LogState) => state.logString,
};

const { read } = getStoreAccessors<LogState, State>("");

export const readLogContent = read(getters.logContent);
